/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import { fetchGraphQL, mutateGraphQL } from '../helpers/dataHelpers';
import authService from '../providers/auth-service';
import {
  QUERY_CREDITS,
  QUERY_CREDITS_MANY,
  QUERY_CREDIT,
  CREATE_CREDIT,
} from '../graphql/oneOffCredits';
import model from '../models/oneOffCredits';

const oneOffCreditsProvider = {
  getList: async (resource, params) => {
    return fetchGraphQL(QUERY_CREDITS, resource, params);
  },

  getOne: async (resource, params) => {
    return fetchGraphQL(QUERY_CREDIT, resource, params);
  },

  getMany: async (resource, params) => {
    return fetchGraphQL(QUERY_CREDITS_MANY, resource, params);
  },

  getManyReference: (resource, params) => Promise,

  create: async (resource, params) => {
    const paramsData = params.data;

    const username = authService.getUsername();
    const credit = model(paramsData, { creation: true, username });

    const response = await mutateGraphQL(
      CREATE_CREDIT,
      {
        oneoff: credit,
      },
      'createOneOffCredits'
    );

    return response;
  },

  update: async (resource, params) => Promise,

  updateMany: async (resource, params) => Promise,

  delete: (resource, params) => Promise,

  deleteMany: (resource, params) => Promise,
};

export default oneOffCreditsProvider;
